import { render } from "./ContentFlagging.vue?vue&type=template&id=48e3408f"
import script from "./ContentFlagging.vue?vue&type=script&lang=js"
export * from "./ContentFlagging.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__